module.exports = __webpack_public_path__ + "static/media/icon-mini-white-selected.e0ef6512.svg";